// import CollapseHelper from '../components/CollapseHelper';

export default {
    init() {
        // JavaScript to be fired on the home page
    },
    finalize() {
        // CollapseHelper.init();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/career.js